import { useAtomValue, useSetAtom } from 'jotai';
import React from 'react';

import { Services } from '@ekhodealer/ekho-common';
import { Badge,Button, Group, TextInput } from '@ekhodealer/ekho-common/rev';

import type { InventoryServiceConfig} from '@ekhodealer/ekho-common';

import { RefreshButton } from '@common/components/RefreshButton';
import { useCurrentServicesProvider } from '@common/hooks/useCurrentServicesProvider';
import { queries } from '@config/server/queryKeys';

import { openFiltersDrawerAtom } from '../atoms/filtersDrawerAtoms';
import { appliedFiltersCountAtom, searchValueAtom } from '../atoms/inventoryAtoms';

import { useSearchAction } from './actions';
import { ImportInventoryModal } from './ImportInventoryModal';

export function InventoryToolbar() {
	// Import modal state
	const [isImportModalOpen, setIsImportModalOpen] = React.useState(false);

	const { data: servicesProvider } = useCurrentServicesProvider();
	const isImportEnabled =
		(servicesProvider?.config?.[Services.INVENTORY] as InventoryServiceConfig | undefined)
			?.adminPortalConfig?.importInventoryEnabled ?? false;

	// Filters drawer atoms
	const openFiltersDrawer = useSetAtom(openFiltersDrawerAtom);
	const appliedFiltersCount = useAtomValue(appliedFiltersCountAtom);

	// Search value atoms
	const searchValue = useAtomValue(searchValueAtom);

	// Action hooks
	const { handleSearchChange } = useSearchAction();

	// All Filters button with optional badge
	const allFiltersButton = (
		<Button variant='outline' size='large' onPress={() => openFiltersDrawer()}>
			All filters
		</Button>
	);

	return (
		<>
			<Group itemsAlignY='center' itemsAlignX='space-between' noWrap>
				<Group.Item>
					<TextInput
						placeholder='Search'
						type='search'
						size='small'
						value={searchValue}
						onChange={handleSearchChange}
					/>
				</Group.Item>
				<Group.Item>
					<Group itemsSpacing={12}>
						<RefreshButton
							queryKeys={[queries.inventory.list._def, queries.inventory.detail._def]}
							ariaLabel='Refresh inventory'
						/>
						{appliedFiltersCount > 0 ? (
							<Badge
								appearance='negative'
								variant='solid'
								size='large'
								placement='top right'
								label={appliedFiltersCount.toString()}>
								{allFiltersButton}
							</Badge>
						) : (
							allFiltersButton
						)}
						{isImportEnabled && (
							<Button
								variant='filled'
								size='large'
								onPress={() => setIsImportModalOpen(true)}>
								Import
							</Button>
						)}
					</Group>
				</Group.Item>
			</Group>

			{/* Import Inventory Modal */}
			<ImportInventoryModal isOpen={isImportModalOpen} onOpenChange={setIsImportModalOpen} />
		</>
	);
}
